import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable, BehaviorSubject, catchError} from 'rxjs';
import {DataService} from '../data.service';
import {AgencyMaster} from 'src/app/shared/common-components/common-structure';
import {LoggerService} from '../../shared/common-components/logger.service';
import {CustomerRegistration} from '../../features/customer-registration/customer-registration';


@Injectable({
  providedIn: 'root'
})
export class CustomerRegistrationService extends DataService {

  private baseURI = this.apiUri + '/public/customerregistration/';
  private observable$: any;
  private _logger: LoggerService;

  public customerApprovalFormState = new BehaviorSubject<any>(null);

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  getConfirmation(confirmation: string): Observable<any> {
    this.setUri(this.baseURI);
    let params: HttpParams = new HttpParams();
    params = params.set('confirmation', confirmation);
    return this.get({params});
  }

  getByRegistrationStatus(registrationStatus: string): Observable<any> {
    this.setUri(this.baseURI + 'registrationStatus/');
    let params: HttpParams = new HttpParams();
    params = params.set('registrationStatus', registrationStatus);
    return this.get({params});
  }

  getAll(): Observable<any> {
    this.setUri(this.baseURI);
    return this.get();
  }

  getCustomers(registrationType: string, registrationStatus: string, userId: number): Observable<any> {
    this.setUri(this.baseURI + 'typeandstatus');
    // this.setUri(this.baseURI + '/customerregistration/typeandstatus/');
    let params: HttpParams = new HttpParams();
    params = params.append('registrationType', registrationType);
    params = params.append('registrationStatus', registrationStatus);
    params = params.append('userId', '' + userId);
    return this.get({params});
  }

  getEmailCheck(emailcheck: string): Observable<any> {
    this.setUri(this.baseURI + emailcheck + '/email');
    return this.get();
  }

  getRegistrationDetailsForEmail(email: string): Observable<any> {
    this.setUri(this.baseURI + email + '/emailId/');
    return this.http.get(this.baseURI + email + '/emailId/');
  }

  getRegistration(userRegisterId: any): Observable<any> {
    this.setUri(this.baseURI + 'userRegisterId');
    let params: HttpParams = new HttpParams();
    params = params.append('userRegisterId', userRegisterId);
    return this.get({params});
  }

  getAllAgency(): Observable<AgencyMaster[]> {
    if (!this.observable$) {
      this.setUri(this.baseURI + 'agency/');
      this.observable$ = this.http.get(this.baseURI + 'agency/').pipe(catchError(this.handleError));
    }
    return this.observable$;
  }

  getAllBureauForAgency(agencyCode): Observable<any> {
    this.setUri(this.baseURI + agencyCode + '/bureau');
    return this.http.get(this.baseURI + agencyCode + '/bureau').pipe(catchError(this.handleError));
  }

  getAllReportingOfficial(agencyCode, bureauCode): Observable<any> {
    this.setUri(this.baseURI + agencyCode + '/agency/' + bureauCode + '/bureau');
    return this.http.get(this.baseURI + agencyCode + '/agency/' + bureauCode + '/bureau').pipe(catchError(this.handleError));
  }

  getAllStates(stateCountryType): Observable<any> {
    this.setUri(this.baseURI + stateCountryType + '/statecountrytype');
    return this.http.get(this.baseURI + stateCountryType + '/statecountrytype');
  }

  export(customers): Observable<any> {
    return this.http.post(this.baseURI + 'export', customers);
  }

  createCustomer(customerRegister: CustomerRegistration): Observable<any> {
    return this.http.post(this.baseURI + 'saveregistration', customerRegister, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  getCustomerDetails(userRegisterId: any): Observable<any> {
    this.setUri(this.baseURI + userRegisterId + '/userregisterid');
    return this.http.get(this.baseURI + userRegisterId + '/userregisterid').pipe(catchError(this.handleError));
  }

  /*
  getReportingOfficial(repOfficialId: any): Observable<any> {
      this.setUri(this.baseURI + repOfficialId + '/organizationid/');
      return this.http.get(this.baseURI + repOfficialId + '/organizationid/').pipe(catchError(this.handleError));
  }
  */
  getCityState(zip: any): Observable<any> {
    this.setUri(this.baseURI + zip + '/zipcode');
    return this.http.get(this.baseURI + zip + '/zipcode').pipe(catchError(this.handleError));
  }

  updateCustomer(customerRegister: CustomerRegistration): Observable<any> {
    return this.http.post(this.baseURI + 'confirmregistration', customerRegister).pipe(catchError(this.handleError));
  }

  /*saveOktaUser(user: any): Observable<any> {
      return this.http.post(this.baseURI + 'saveoktauser/', user).pipe(catchError(this.handleError));
  }*/
  saveOktaUser(user: any): Observable<any> {
    return this.http.post(this.baseURI + 'saveoktauser', user, {responseType: 'text'});
  }

  getEmailBusinessTypeCheck(emailcheck: string, businessType: string): Observable<any> {
    this.setUri(this.baseURI + emailcheck + '/email/' + businessType + '/businessType');
    return this.get();
  }
}
